// extracted by mini-css-extract-plugin
export default {"name":"preform-catalog-table_name__N7I6Z","symbol":"preform-catalog-table_symbol__Rzi5a","actions":"preform-catalog-table_actions__+Sz0y"};